<div *ngIf="tiles && tiles?.length > 0">
  <div class="vm-row">
    <div *ngFor="let tile of tiles" class="vm-col-xs-12 vm-col-sm-6 vm-col-md-4 vm-col-lg-4">
      <ng-container *ngIf="tile.isVisible">
        <div class="vm-tile-container" [class.has-hover]="tile?.link">
          <a
            *ngIf="!isExternalLinkRegex.test(tile?.link); else externalLinkBlock"
            class="tile-nav-link"
            [routerLink]="tile?.link">
            <ng-template [ngTemplateOutlet]="innerTile"></ng-template>
          </a>

          <ng-template #externalLinkBlock>
            <a class="tile-nav-link" [href]="tile?.link">
              <ng-template [ngTemplateOutlet]="innerTile"></ng-template>
            </a>
          </ng-template>

          <ng-template #innerTile>
            <div *ngIf="!tile?.icon" class="tile-icon mb-24">
              <vm-media [source]="tile?.iconSrc | mediaSrcStrapi: strapiUrl" [altText]="tile?.alt"></vm-media>
            </div>
            <div *ngIf="tile?.icon">
              <ng-container [ngSwitch]="tile?.iconWeight">
                <i
                  *ngSwitchCase="IconWeight.LIGHT"
                  class="tile-icon fal fa-fw"
                  ngClass="fa-{{ tile?.icon }}"
                  [style.color]="tile?.iconColor"></i>
                <i
                  *ngSwitchCase="IconWeight.REGULAR"
                  class="tile-icon far fa-fw"
                  ngClass="fa-{{ tile?.icon }}"
                  [style.color]="tile?.iconColor"></i>
                <i
                  *ngSwitchCase="IconWeight.SOLID"
                  class="tile-icon fas fa-fw"
                  ngClass="fa-{{ tile?.icon }}"
                  [style.color]="tile?.iconColor"></i>
                <i
                  *ngSwitchCase="IconWeight.DUOTONE"
                  class="tile-icon fad fa-fw"
                  ngClass="fa-{{ tile?.icon }}"
                  [style.color]="tile?.iconColor"></i>
                <i
                  *ngSwitchCase="IconWeight.BRANDS"
                  class="tile-icon fab fa-fw"
                  ngClass="fa-{{ tile?.icon }}"
                  [style.color]="tile?.iconColor"></i>
                <i
                  *ngSwitchDefault
                  class="tile-icon fa fa-fw"
                  ngClass="fa-{{ tile?.icon }}"
                  [style.color]="tile?.iconColor"></i>
              </ng-container>
            </div>
            <div *ngIf="tile?.title" class="tile-nav-link-content">
              <h3 class="tile-nav-link__title">{{ tile?.title }}</h3>
            </div>
            <div *ngIf="tile?.copy" class="tile-nav-link-content">
              <p class="tile-nav-link__text">{{ tile?.copy }}</p>
            </div>
            <ng-content></ng-content>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</div>
